function resolve (obj, key) {
  if (!key)
    return obj
  const subkeys = key.replace(/\[([\w\d_-]*)\]/g, '.$1').split('.');
  let returnObj = obj;
  while (subkeys.length > 0 && returnObj !== undefined) {
    const prop = subkeys.shift();
    returnObj = returnObj?.[prop];
  }
  return returnObj
}

export { resolve as r };
//# sourceMappingURL=resolve-CcNBIfOU.js.map
